import { jwtDecode } from "jwt-decode";

const AUTH_STORAGE_KEYS = ["authToken", "user", "dup-authToken", "dup-user"];

const decodeToken = (token) => {
  if (!token) return null;

  try {
    return jwtDecode(token);
  } catch (err) {
    return null;
  }
};

export const clearAuthStorage = () => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const getToken = () => {
  const tokenFromStorage = localStorage.getItem("authToken");

  if (!tokenFromStorage) return null;

  try {
    const parsedToken = JSON.parse(tokenFromStorage);
    return typeof parsedToken === "string" ? parsedToken : null;
  } catch (err) {
    return tokenFromStorage;
  }
};

export const getTokenExpiryTime = (token) => {
  const decodedToken = decodeToken(token);

  if (typeof decodedToken?.exp !== "number") return null;

  return decodedToken.exp * 1000;
};

export const getTimeUntilTokenExpiry = (token) => {
  const tokenExpiryTime = getTokenExpiryTime(token);

  if (typeof tokenExpiryTime !== "number") return 0;

  return Math.max(tokenExpiryTime - Date.now(), 0);
};

export const isTokenExpired = (token) => {
  if (!token) return true;
  return getTimeUntilTokenExpiry(token) <= 0;
};

export const isAuthenticated = () => {
  const token = getToken();

  if (!token) return false;

  return !isTokenExpired(token);
};
